<template>
  <div class="t-flex-grow t-mr-8 t-border-t-2 t-border-gray-400">
    <div v-if="featuredTimelineItem" class="t-mb-5 t-border-b-2 t-border-gray-400 t-pb-8">
      <p class="t-mt-4 t-font-semibold">
        Most Recent Update
      </p>
      <p class="t-text-2xl t-font-semibold t-text-dodger-blue">
        {{ featuredTimelineItem.content }}
      </p>

      <div class="t-w-32">
        <p>{{ featuredTimelineItem.day }}</p>
        <p>{{ featuredTimelineItem.time }}</p>
      </div>
    </div>

    <div v-else class="t-mt-4">
      <h5>Sorry, there is no information.</h5>
      <h5>Please contact Freighthub for more information.</h5>
    </div>

    <div
      v-for="(timelineItem, idx) in timelineItems"
      :key="idx"
      class="t-flex t-mt-4 t-border-b t-border-gray-400 t-pb-4"
    >
      <div class="t-w-32">
        <p>{{ timelineItem.day }}</p>
        <p>{{ timelineItem.time }}</p>
      </div>
      <p>{{ timelineItem.content }}</p>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: 'FreightMovementTimeline',
  props: {
    freightMovements: {

    },
    booking: {

    }
  },
  data() {
    return {
      featuredTimelineItem: null,
      timelineItems: null
    }
  },
  created() {
    if (this.freightMovements.length > 0) {
      this.featuredTimelineItem = this.freightMovements.pop();
      this.timelineItems = this.freightMovements.reverse();
    }
  },
  methods: {
    moment: function (...args) {
      return moment(...args);
    }
  }
}
</script>

<style scoped>

</style>
